import React from "react";

const Error = () => (
  <>
    <h2>Purchase failed</h2>
    <p>The purchase unfortunately failed. No money was charged.</p>
  </>
);

export default Error;
